import React from 'react';
import { useCallback } from 'react';
import { StyleSheet } from 'react-native';
import { FlatList } from 'react-native-gesture-handler';

import { useNavigation } from '@react-navigation/native';

import { SizedBox } from '@/components/SizedBox';
import { ds } from '@/components/lib/design.system';
import { GASbkEvents } from '@/feature/analytics/sbk/ga-sbk-events';
import { Event } from '@/feature/event-details-sbk/types';
import { useEventsTabsStore } from '@/hooks/use-events-tabs-store';
import { SweepsLobbyTabNavigationProp } from '@/navigation/sweeps/types';
import { showScrollIndicator } from '@/utils/constants-platform-specific';

import { SbkEventCard } from './SbkEventCard';

type EventTickerProps = {
    events: Event[];
};

const keyExtractor = (item: Event) => item.id;
export const ItemSeparator = () => <SizedBox value={12} />;

export const EventsTray = ({ events }: EventTickerProps) => {
    const navigation = useNavigation<SweepsLobbyTabNavigationProp>();
    const navigateToEvent = useCallback(
        (event: Event, index: number) => {
            useEventsTabsStore.getState().actions.setSelectedTab(index);
            GASbkEvents.clickEvent(event.id);
            navigation.navigate('SbkEventsSheets', {
                eventId: event.id,
                contextKey: new Date().getTime().toString(),
                leagueId: event?.league?.id,
            });
        },
        [navigation]
    );

    const renderItem = useCallback(
        ({ item, index }: { item: Event; index: number }) => (
            <SbkEventCard event={item} navigateToEvent={() => navigateToEvent(item, index)} />
        ),
        [navigateToEvent]
    );

    return (
        <FlatList
            data={events}
            renderItem={renderItem}
            keyExtractor={keyExtractor}
            ItemSeparatorComponent={ItemSeparator}
            horizontal
            style={styles.flatList}
            ListHeaderComponent={<SizedBox value={16} />}
            ListFooterComponent={<SizedBox value={16} />}
            showsHorizontalScrollIndicator={showScrollIndicator}
            testID="eventTickerFlatList"
        />
    );
};

export const styles = StyleSheet.create({
    flatList: {
        backgroundColor: ds.colorValue.background.neutral.base,
    },
});
